import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { lesp_item } from "../../../json/lesp";
import "../stylessh.css";

const Lesp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderText = () => {
    const { lesp_item_text, lesp_item_list } = lesp_item[0];

    return (
      <div>
        <p className="text-justify">{lesp_item_text}</p>
        <ul className="list-mark">
          {lesp_item_list.map((item, index) => (
            <li key={index}>{typeof item === "object" ? <a href={item.url}>{item.label}</a> : item}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Laboratorio Estatal de Salud Pública</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
        {renderText()}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14985.759175707539!2d-98.78647621645507!3d20.11569172280845!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x609c37f38bb27cfa!2sLaboratorio%20Estatal%20de%20Salud%20P%C3%BAblica%20Hidalgo!5e0!3m2!1ses-419!2smx!4v1666022083571!5m2!1ses-419!2smx"
          width="100%"
          height="300"
          frameBorder="0"
          style={{ border: 0, marginBottom: 50 }}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Lesp;

